module.exports = __webpack_public_path__ + "img/Large-Horizontal-Rectangular-Attachment-41.489fdced.png";